/**
 * AppLayout.tsx - Following exact UI/UX design specifications
 * Main layout component with sidebar and responsive behavior
 */
import React from 'react';
import {Outlet} from 'react-router-dom';
import Header from '@/components/layout/Header';
import Sidebar from '@/components/layout/Sidebar';

export const AppLayout: React.FC = () => {
    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100">
            {/* Fixed Header */}
            <Header/>

            {/* Fixed Sidebar */}
            <Sidebar/>

            {/* Main Content Area - Responsive to sidebar state */}
            <main className="pt-16 min-h-screen transition-all duration-300 ease-in-out ml-64">
                <Outlet/>
            </main>
        </div>
    );
};
